import { z } from "zod";
import { OMO } from "@/lib/data/words";
import { createExerciseStore } from "./create-exercise-store";

export const omoStore = createExerciseStore(
  "omo",
  OMO,
  z.object({
    selected: z.number(),
    correct: z.boolean(),
    timestamp: z.number(),
  }),
  (attempts) => (attempts[0]?.correct ? 100 : 0),
);
